import styled from 'styled-components';
import ArticleCard from '../components/ArticleCard.js';
import { mediaQueries } from "../shared/config";
import { useMediaQuery } from 'react-responsive';

const NewsGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 2fr);
    grid-template-rows: repeat(9, 29.95vh);

    background: #C7BDAC;

    font-family: "Oswald", sans-serif;
    font-weight: 600;
    font-size: 18vh;

    border: 2px solid black;
    line-height: 22vh;


    .N {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    .E {
        grid-row: 1;
        grid-column: 2;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

    .W {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }

    .S {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 1.5vh;
    }
    

    .B3 {
        grid-row: 3;
        grid-column: 1;
        border: inherit;
    }

    .B4 {
        grid-row: 3;
        grid-column: 4;
        border: inherit;
    }

    .B5 {
        grid-row: 7;
        grid-column: 1;
        border: inherit;
    }
    .B6 {
        grid-row: 7;
        grid-column: 4;
        border: inherit;
    }

        .B12 {
        grid-row: 9;
        grid-column: 1;
        border: inherit;
    }

        .B13 {
        grid-row: 9;
        grid-column: 4;
        border: inherit;
    }

    .A1 {
        grid-row: 1;
        grid-column: 3 / 5;
        border: inherit;
   
    }

    .A2 {
        grid-row: 2;
        grid-column: 1 / 3;
        border: inherit;
        
    }

    .A3 {
        grid-row: 3;
        grid-column: 2 / 4;
        border: inherit;
       
    }

    .A4 {
        grid-row: 4;
        grid-column: 1/3;
        border: inherit;
        
    }

    .A5 {
        grid-row: 4;
        grid-column: 3/5;
        border: inherit;
       
    }

    .A6 {
        grid-row: 5;
        grid-column: 1/3;
        border: inherit;
       
    }

    .A7 {
        grid-row: 5;
        grid-column: 3/5;
        border: inherit;
     
    }

    .A8 {
        grid-row: 6;
        grid-column: 1/3;
        border: inherit;
    
    }

    .A9 {
        grid-row: 6;
        grid-column: 3/5;
        border: inherit;
      
    }

    .A10 {
        grid-row: 7;
        grid-column: 2/4;
        border: inherit;
     
    }

    .A11 {
        grid-row: 8;
        grid-column: 1/3;
        border: inherit;
    
    }

    .A12 {
        grid-row: 8;
        grid-column: 3/5;
        border: inherit;
      
    }

    .A13 {
        grid-row: 9;
        grid-column: 2/4;
        border: inherit;
     
    }
   
`;

const MobileNews = styled("div")`
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    grid-template-rows: repeat(2, 20vh);

    background: #C7BDAC;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 10vh;

    border: 2px solid black;
    line-height: 22vh;


    .N {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
    }
    .E {
        grid-row: 1;
        grid-column: 2;
        border: inherit;
    }

    .W {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
    }

    .S {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
    }
   
`

const Container = styled.div`
    margin: 0 auto;
    position: relative;
    height: auto;
    padding: 0;
    width: 100%;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    
    gap: 0px;
    ${mediaQueries.mobile} {
        grid-template-columns: repeat(1, 1fr);
    }
`;

const News = (props) => {
    let a1 = props.news[0];
    let a2 = props.news[1];
    let a3 = props.news[2];
    let a4 = props.news[3];
    let a5 = props.news[4];
    let a6 = props.news[5];
    let a7 = props.news[6];
    let a8 = props.news[7];
    let a9 = props.news[8];
    let a10 = props.news[9];
    let a11 = props.news[10];
    let a12 = props.news[11];
    let a13 = props.news[12];
    const isMobile = useMediaQuery({ query: '(max-width: 436px)' });

    return (
        <>

            {!isMobile ? (
                <>
                      <NewsGrid>
                <div class="N">N</div>
                <div class="E">E</div>
                <div class="A1">
                <ArticleCard
                        position='left'
                        article_title={a1.article_title}
                        article_byline={a1.article_byline}
                        article_image={a1.article_image}
                        article_url={a1.article_url}
                        ></ArticleCard>
                </div>
                <div class="A2">
                <ArticleCard
                        position='right'
                        article_title={a2.article_title}
                        article_byline={a2.article_byline}
                        article_url={a2.article_url}
                        article_image={a2.article_image}></ArticleCard>
                </div>
                <div class="W">W</div>
                <div class="S">S</div>
                <div class="B3"></div>
                <div class="A3">
                <ArticleCard
                        position='left'
                        article_title={a3.article_title}
                        article_byline={a3.article_byline}
                        article_url={a3.article_url}
                        article_image={a3.article_image}></ArticleCard>
                </div>
                <div class="B4"></div>

                <div class="A4">
                <ArticleCard
                        position='right'
                        article_url={a4.article_url}
                        article_title={a4.article_title}
                        article_byline={a4.article_byline}
                        article_image={a4.article_image}></ArticleCard>
                </div>
                <div class="A5">
                <ArticleCard
                        position='left'
                        article_title={a5.article_title}
                        article_byline={a5.article_byline}
                        article_url={a5.article_url}
                        article_image={a5.article_image}></ArticleCard>
                </div>

                <div class="A6">
                <ArticleCard
                        position='left'
                        article_title={a6.article_title}
                        article_byline={a6.article_byline}
                        article_url={a6.article_url}
                        article_image={a6.article_image}></ArticleCard>
                </div>
                <div class="A7">
                <ArticleCard
                        position='right'
                        article_title={a7.article_title}
                        article_byline={a7.article_byline}
                        article_url={a7.article_url}
                        article_image={a7.article_image}></ArticleCard>
                </div>

                <div class="A8">
                <ArticleCard
                        position='right'
                        article_title={a8.article_title}
                        article_url={a8.article_url}
                        article_byline={a8.article_byline}
                        article_image={a8.article_image}></ArticleCard>
                </div>
                <div class="A9">
                <ArticleCard
                        position='left'
                        article_title={a9.article_title}
                        article_byline={a9.article_byline}
                        article_url={a9.article_url}
                        article_image={a9.article_image}></ArticleCard>
                </div>
                

                <div class="B5"></div>
                <div class="A10">
                <ArticleCard
                        position='left'
                        article_title={a10.article_title}
                        article_byline={a10.article_byline}
                        article_url={a10.article_url}
                        article_image={a10.article_image}></ArticleCard>
                </div>
                <div class="B6"></div>


                <div class="A11">
                <ArticleCard
                        position='right'
                        article_title={a11.article_title}
                        article_byline={a11.article_byline}
                        article_url={a11.article_url}
                        article_image={a11.article_image}></ArticleCard>
                </div>
                <div class="A12">
                <ArticleCard
                        position='left'
                        article_title={a12.article_title}
                        article_byline={a12.article_byline}
                        article_url={a12.article_url}
                        article_image={a12.article_image}></ArticleCard>
                </div>

                <div class="B12"></div>
                <div class="A13">
                <ArticleCard
                        position='left'
                        article_title={a13.article_title}
                        article_url={a13.article_url}
                        article_byline={a13.article_byline}
                        article_image={a13.article_image}></ArticleCard>
                </div>
                <div class="B13"></div>

            </NewsGrid> 
                </>
            ) : (
                <>
                    <MobileNews>
                        <div class="N">N</div>
                        <div class="E">E</div>
                        <div class="W">W</div>
                        <div class="S">S</div>
                    </MobileNews>
                    <Container>
                        <Grid>
                            {props && props.news ? props.news.map((item, index) => {
                                return (
                                    <ArticleCard
                                            key={index}
                                            position={index % 2 === 0 ? "left" : "right"}
                                            color={"#C6BCAB"}
                                            article_title={item.article_title}
                                            article_byline={item.article_byline}
                                            article_image={item.article_image}></ArticleCard>
                                );
                            }) : null}
                        </Grid>
                    </Container>
                </>
            )}
            

        </>
    )
}

export default News;

